module.exports = __webpack_public_path__ + "img/player-white.09895402.png";